import(/* webpackMode: "eager" */ "/vercel/path0/apps/admin/app/not-found.tsx");
